import type { ReactNode } from 'react'

/**
 * A full-screen state on the public view path — loading, rate-limited, or
 * failed. Recipients have no account and no app chrome around them, so each of
 * these is the entire page they see; they get the same composed treatment as
 * the album itself rather than a sentence stranded at the top of a white page.
 *
 * LinkUnavailable is the fourth state and shares this layout, adding the mark
 * and the frame that only make sense when the memories are deliberately closed.
 */
export default function ViewMessage({
  title,
  note,
  action,
}: {
  title: string
  note?: string
  action?: ReactNode
}) {
  return (
    <main className="view-state">
      <h1 className="view-state__title">{title}</h1>
      {note && <p className="view-state__note">{note}</p>}
      {action}
    </main>
  )
}
